
import Vue from 'vue'
import { State } from 'vuex-class'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

import { INotificationService } from '../services/NotificationService'
import UserService from '../services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import PasswordHelpCard from '@/components/PasswordHelpCard.vue'
import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import BlockButton from '../components/Atomic/BlockButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    PasswordHelpCard,
    GreenButton,
    RedButton,
    BlockButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class ChangePassword extends Vue {
  // Should be provided when a user has just logged in with his generated password.
  // Hides the old password input if so.
  @Prop(String) public readonly loggedInPassword: string
  @Prop(String) public readonly username: string | undefined

  @State('user') private user!: any

  private showOldPassword: boolean = false
  private showNewPassword: boolean = false
  private showNewPasswordConfirmation: boolean = false

  private oldPassword: string = ''
  private newPassword: string = ''
  private confirmPassword: string = ''

  private specialCharacters: string = '-!@#$%^&*_`+=()\\[\\]{}"\'<>.?/'
  private defaultRegExp = new RegExp(`^(?!.*[\\s])(?=[a-zA-Z0-9${this.specialCharacters}{10,64}$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])`, 'g')
  private studentRegExp = new RegExp(`^(?!.*[\\s])(?=[a-zA-Z0-9${this.specialCharacters}]{6,64}$)(?=.*[0-9])(?=.*[a-zA-Z])`, 'g')
  private activeRegExp!: RegExp

  private isPending: boolean = false
  private $notificationService: INotificationService = {} as any
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()

  private created() {
    this.activeRegExp = this.user.isStudent
      ? this.studentRegExp
      : this.defaultRegExp
    this.oldPassword = this.loggedInPassword
  }

  private async save() {
    this.isPending = true
    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        await UserService.changePassword(
          this.username,
          this.oldPassword,
          this.newPassword,
        )
        this.$notificationService.success(
          this.$t('CHANGEPASSWORD.ChangeSuccess').toString(),
        )
        this.$router.go(-1)
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      } finally {
        this.isPending = false
      }
    }
    this.isPending = false
  }

  private cancel() {
    this.$router.go(-1)
  }
}
